import { render, staticRenderFns } from "./event202108.vue?vue&type=template&id=737e4b80&scoped=true&"
import script from "./event202108.vue?vue&type=script&lang=js&"
export * from "./event202108.vue?vue&type=script&lang=js&"
import style0 from "./event202108.vue?vue&type=style&index=0&id=737e4b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737e4b80",
  null
  
)

export default component.exports